import { Card, CardBody, Col } from 'reactstrap';
import CardHeaderCommon from '../../../../CommonElements/CardHeaderCommon/CardHeaderCommon';
import CommonFileUpload from '../../../../CommonElements/CommonFileUpload';
import { fileUploadData } from '../../../../Data/BonusUi/Dropzone/Dropzone';
import { SingleFileUploads } from '../../../../utils/Constant';

const SingleFileupload = () => {
    
      return (
        <Col lg="6">
          <Card>
            <CardHeaderCommon title={SingleFileUploads} span={fileUploadData} />
            <CardBody>
              <CommonFileUpload />
            </CardBody>
          </Card>
        </Col>
      );
}

export default SingleFileupload